module.exports = __webpack_public_path__ + "img/downArrow.8e751597.svg";